// extracted by mini-css-extract-plugin
export default {"checkbox":"JRDyJ","box":"GSDZb","label":"Imy_L"};